"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MIN_PAYMENT_TERM_DAYS = exports.MAX_PAYMENT_TERM_DAYS = exports.MAX_DISCOUNT_DURATION_DAYS = exports.MIN_DISCOUNT_DURATION_DAYS = exports.MIN_DISCOUNT_PERCENTAGE = exports.MAX_DISCOUNT_PERCENTAGE = void 0;
exports.MAX_DISCOUNT_PERCENTAGE = 100;
exports.MIN_DISCOUNT_PERCENTAGE = 0.01;
exports.MIN_DISCOUNT_DURATION_DAYS = 1;
exports.MAX_DISCOUNT_DURATION_DAYS = 365;
exports.MAX_PAYMENT_TERM_DAYS = 730;
exports.MIN_PAYMENT_TERM_DAYS = 1;
